import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  API_CONSTANTS,
  TOP_RECORDS_LIMIT,
  ACTION_ITEM_STATUS,
} from '../Utils/constants'
import {
  getUtcUnixDate,
  getCurrentTimeMoment,
  getStartDate,
} from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'

export default class ActionItemsStore extends FetchBase {
  @observable actionItemSearchText = ''
  @observable actionItemsFilters = {}
  @observable pfSelectedDateChoice = undefined
  @observable ordering = undefined
  @observable orderingField = undefined
  @observable allActionItems = []
  @observable allActionItemsLoader = false
  @observable allActionItemsToal = 0
  @observable isUserAssignedInActionItem = false
  @observable allActionItemsPageNo = DEFAULT_PAGE_START
  @observable allOverdueActionItemsLoader = false
  @observable allOverdueActionItems = []
  @observable allOverdueActionItemsTotal = 0
  @observable allActionItemsPriority = []
  @observable allActionItemsPriorityLoader = false

  @observable allActionItemsStatus = []
  @observable allActionItemsStatusLoader = false

  @observable addActionItemLoader = false
  @observable deleteActionItemLoader = false

  @observable actionItemLoader = false
  @observable actionItem = {}
  @observable actionItemChangeStatusLoader = undefined

  @observable actionItemAttachmentTextSearch = ''
  @observable setCheckActionBulk = []
  @observable setCheckeFileList = []
  @observable allActionItemsAttachmentLoader = false
  @observable allActionItemsAttachment = []
  @observable allActionItemsAttachmentTotal = 0
  @observable isUserAssignedInActionItem = false

  @action.bound
  setActionItemFilters = (values = {}) => {
    this.actionItemsFilters = values
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingField = (value = undefined) => {
    if (value === 'space') {
      value = 'spaceName'
    } else if (value === 'actionitems') {
      value = 'title'
    }
    this.orderingField = value
  }

  @action.bound
  setActionItemSearchText = (value = '') => {
    this.actionItemSearchText = value
  }

  @action.bound
  setAllActionItemsPageNo = (page = DEFAULT_PAGE_START) => {
    this.allActionItemsPageNo = page
  }

  @action.bound
  getAllActionItemsExport = async (
    projectId,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let options = this.generateActionItemFilters()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_ACTION_ITEMS, {
        projectId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  generateActionItemFilters = () => {
    let temp = {}

    this.actionItemSearchText && (temp['search'] = this.actionItemSearchText)
    let keys = Object.keys(this.actionItemsFilters || {})
    for (let filter of keys) {
      if (this.actionItemsFilters[filter] !== undefined) {
        temp[filter] = this.actionItemsFilters[filter]
      }
    }

    if (temp['endDate']) {
      temp['endDateMax'] = getStartDate(temp['endDate'])
    }
    let { start, end } = getUtcUnixDate(this.pfSelectedDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']
    temp['startDate'] && delete temp['endDateMax']

    delete temp['choice']
    delete temp['dateChoice']

    this.ordering && (temp['ordering'] = this.ordering)
    this.ordering && (temp['orderBy'] = this.orderingField)

    return temp
  }

  @action.bound
  getAllActionItems = async (projectId, signal) => {
    try {
      this.allActionItemsLoader = true
      let options = this.generateActionItemFilters() || {}
      let response = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEMS,
        {
          projectId,
          pageNo: Math.max(this.allActionItemsPageNo - 1, 0),
          pageLimit: 10,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.allActionItems = response.data.actionItems
        this.allActionItemsToal = response.data.total || 0
        this.isUserAssignedInActionItem = response?.isUserAssigned
        return [true, response.data]
      }
      this.allActionItems = []
      this.allActionItemsToal = 0
      this.isUserAssignedInActionItem = false
      return [false, undefined]
    } catch (err) {
      this.allActionItems = []
      this.allActionItemsToal = 0
      this.isUserAssignedInActionItem = false
      return [false, undefined]
    } finally {
      this.allActionItemsLoader = false
    }
  }

  @action.bound
  getOverdueActionItems = async (projectId, signal) => {
    try {
      this.allOverdueActionItemsLoader = true
      let date = getCurrentTimeMoment()
      let options = {}
      options['endDateMax'] = getStartDate(date)
      options['orderBy'] = 'endDate'
      options['ordering'] = 'ASC'
      options['actionStatusId'] = ACTION_ITEM_STATUS?.OPEN
      options['pageLimit'] = TOP_RECORDS_LIMIT
      let response = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEMS,
        {
          projectId,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.allOverdueActionItemsTotal = Math.min(
          response.data.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.allOverdueActionItems = response.data.actionItems
        return [true, response.data]
      }
      this.allOverdueActionItems = []
      this.allOverdueActionItemsTotal = 0
      return [false, undefined]
    } catch (err) {
      this.allOverdueActionItems = []
      this.allOverdueActionItemsTotal = 0
      return [false, undefined]
    } finally {
      this.allOverdueActionItemsLoader = false
    }
  }

  @action.bound
  getAllActionItemsPriority = async (signal, networkOnly = true) => {
    this.allActionItemsPriorityLoader = true
    if (!networkOnly) {
      if (this.allActionItemsPriority?.length) {
        return [true, this.allActionItemsPriority]
      }
    }
    try {
      let respose = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEMS_PRIORITY,
        {},
        signal
      )
      if (respose.status) {
        this.allActionItemsPriority = respose.data
        return [true, respose.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.allActionItemsPriorityLoader = false
    }
  }

  @action.bound
  getAllActionItemsStatus = async (signal, networkOnly = true) => {
    this.allActionItemsStatusLoader = true
    if (!networkOnly) {
      if (this.allActionItemsStatus?.length) {
        return [true, this.allActionItemsStatus]
      }
    }
    try {
      let respose = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEMS_STATUS,
        {},
        signal
      )
      if (respose.status) {
        this.allActionItemsStatus = respose.data
        this.allActionItemsStatus = (this.allActionItemsStatus || []).filter(
          (status) => {
            return status.id !== API_CONSTANTS.OVERDUE_ACTION_ITEM_STATUS_CODE
          }
        )
        return [true, this.allActionItemsStatus]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.allActionItemsStatusLoader = false
    }
  }

  @action.bound
  addActionItem = async (values) => {
    try {
      this.addActionItemLoader = true
      let formdatavalue = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_ACTION_ITEM,
        formdatavalue
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  updateActionItemLocally = (id, newValue) => {
    if (!newValue?.id) {
      return
    }
    this.allActionItems = (this.allActionItems || []).map((actionItem) => {
      if (actionItem.id === newValue.id) {
        return newValue
      }
      return actionItem
    })
  }

  @action.bound
  updateActionItem = async (id, values) => {
    try {
      this.addActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_ACTION_ITEM, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addActionItemLoader = false
    }
  }

  @action.bound
  deleteActionItem = async (id, values) => {
    try {
      this.deleteActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_ACTION_ITEM, {
        ...values,
        id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.deleteActionItemLoader = false
    }
  }

  @action.bound
  getActionItem = async (id, signal) => {
    try {
      this.actionItemLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEM_BY_ID,
        {
          id,
        },
        signal
      )
      if (response.status) {
        this.actionItem = response?.data
        return [true, response.data]
      }
      this.actionItem = {}
      return [false, undefined]
    } catch (err) {
      this.actionItem = {}
      return [false, undefined]
    } finally {
      this.actionItemLoader = false
    }
  }

  @action.bound
  getActionItemByIdLocally = async (res) => {
    if (res?.id) {
      this.actionItem = res
    }
  }

  @action.bound
  uploadActionItemAttachmentsLocally = (image) => {
    if (this.actionItem?.actionAttachments?.length) {
      this.actionItem.actionAttachments =
        this.actionItem.actionAttachments.concat([image])
    } else {
      this.actionItem = { ...this.actionItem, actionAttachments: [image] }
    }
  }

  @action.bound
  uploadActionItemAttachments = async (values) => {
    try {
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_ACTION_ATTACHMENTS,
        generateFormData(values)
      )
      if (response.status) {
        return [true, response.data?.[0]]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
    }
  }

  @action.bound
  deleteAttachmentLocally = (imageId) => {
    if (this.actionItem?.actionAttachments?.length) {
      this.actionItem.actionAttachments = (
        this.actionItem.actionAttachments || []
      ).filter((image) => {
        return imageId !== image.id
      })
    }
  }

  @action.bound
  deleteActionItemAttachment = async (imageId) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ATTACHMENTS, {
        id: imageId,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  changeActionItemStatus = async (id, values = {}) => {
    try {
      this.actionItemChangeStatusLoader = id
      let response = await this.post(API_ENDPOINTS.CHANGE_ACTION_ITEM_STATUS, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.actionItemChangeStatusLoader = undefined
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.actionItemsFilters = {}
    this.pfSelectedDateChoice = undefined
  }

  @action.bound
  setActionItemsAttachmentSearchText = (value = '') => {
    this.actionItemAttachmentTextSearch = value
  }

  @action.bound
  getAllActionItemsAttachment = async (projectId, signal) => {
    try {
      this.allActionItemsAttachmentLoader = true
      let options = {}
      this.actionItemAttachmentTextSearch &&
        (options['search'] = this.actionItemAttachmentTextSearch)
      let response = await this.get(
        API_ENDPOINTS.GET_ACTION_ITEMS,
        {
          projectId,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.allActionItemsAttachment = response.data.actionItems
        this.allActionItemsAttachmentTotal = response.data.total
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.allActionItemsAttachmentTotal = 0
      this.isUserAssignedInActionItem = false
      return [false, undefined]
    } finally {
      this.allActionItemsAttachmentLoader = false
    }
  }

  @action.bound
  setBulkDownloadFile = async (
    isCheck,
    list = [],
    attachments,
    allActionItemsAttachmentTotal
  ) => {
    let newList = attachments.map((listItem) => {
      return listItem.id
    })
    if (isCheck) {
      this.setCheckActionBulk = this.setCheckActionBulk.concat(list)
      this.setCheckeFileList = this.setCheckeFileList.concat(newList)
      this.isBulkActionItemSelect = Boolean(
        allActionItemsAttachmentTotal === this.setCheckActionBulk?.length ||
          1 < this.setCheckActionBulk?.length
      )
    } else {
      let attachmentToDelete = new Set(newList)
      let cleanAttachmentData = this.setCheckeFileList.filter(
        (listItem) => !attachmentToDelete.has(listItem)
      )
      this.setCheckeFileList = cleanAttachmentData
      let cleanSpaceList = this.setCheckActionBulk.filter(
        (listItem) => listItem !== list[0]
      )
      this.setCheckActionBulk = cleanSpaceList
      this.isBulkActionItemSelect = Boolean(
        1 <= this.setCheckActionBulk?.length
      )
    }
  }

  @action.bound
  setDownloadFile = async (list = [], totalFiles, id) => {
    this.setCheckeFileList = list
    this.setCheckActionBulk = list?.length === totalFiles ? [id] : []
  }

  @action.bound
  resetStore = () => {
    this.actionItemSearchText = ''
    this.actionItemsFilters = {}
    this.ordering = undefined
    this.orderingField = undefined
    this.pfSelectedDateChoice = undefined
    this.allActionItems = []
    this.allActionItemsLoader = false
    this.allActionItemsToal = 0
    this.isUserAssignedInActionItem = false
    this.allActionItemsPageNo = DEFAULT_PAGE_START
    this.allOverdueActionItemsLoader = false
    this.allOverdueActionItems = []
    this.allOverdueActionItemsTotal = 0
    this.allActionItemsPriority = []
    this.allActionItemsPriorityLoader = false
    this.allActionItemsStatus = []
    this.allActionItemsStatusLoader = false
    this.addActionItemLoader = false
    this.deleteActionItemLoader = false
    this.actionItemLoader = false
    this.actionItem = {}
    this.actionItemChangeStatusLoader = undefined
    this.actionItemAttachmentTextSearch = ''
    this.setCheckActionBulk = []
    this.setCheckeFileList = []
    this.allActionItemsAttachmentLoader = false
    this.allActionItemsAttachment = []
    this.allActionItemsAttachmentTotal = 0
    this.isUserAssignedInActionItem = false
  }
}
